import { Card, Clipboard, Loading, Text } from '@bit/ume.design-kit.ui'
import { green, red } from '@bit/ume.design-kit.ui/Palette'
import { Box } from 'grommet'
import * as React from 'react'
import styled from 'styled-components'
import { toaster } from '../../App'
import { ResponsiveGrid } from '../../atoms/ResponsiveGrid/ResponsiveGrid'
import { translateSourceProduct } from '../../common/assets/utils/translationUtils'
import { InfoTextStyle, LabelStyle } from '../../pages/CS-Profile/ContractsSummaryCard/style'
import { ISingleInstallment } from '../../services/bff-backoffice/coordinator/interfaces/installment.interfaces'
import { formatDate, formatDateTreatingError, formatNumberToBRL } from '../../utils'
import { DataBoxStyle, DifferenceTextStyle, LinkAnchorStyle } from './style'

export interface IInstallmentDetailsProps {
  installment?: ISingleInstallment | Error
}

export default class InstallmentDetails extends React.PureComponent<IInstallmentDetailsProps> {
  public render() {
    const { installment } = this.props

    const errorCard = (
      <Text color="red" light>
        Não foi possível carregar os dados para esta parcela.
      </Text>
    )

    const differenceValue = (paymentDue: number, installmentValue: number, paidValue?: number) => {
      let difference = 0

      if (paidValue) {
        difference = paidValue - installmentValue
      } else {
        difference = paymentDue - installmentValue
      }

      if (difference > 0) {
        return <DifferenceTextStyle color={red.primary}>{'+' + formatNumberToBRL(difference)}</DifferenceTextStyle>
      } else {
        return <DifferenceTextStyle color={green.darkPastel}>{formatNumberToBRL(difference)}</DifferenceTextStyle>
      }
    }

    const paymentMethodString = (method: string, paymentTimestamp?: string) => {
      if (!paymentTimestamp) {
        return '-'
      }
      switch (method) {
        case 'STORE':
          return 'Loja'
        case 'INVOICE':
          return 'Boleto'
        case 'RENEGOTIATION':
          return 'Renegociação'
        default:
          return '-'
      }
    }

    const InstallmentDetailsCard = (installment: ISingleInstallment) => {
      const sortedInvoices = installment?.invoices?.sort((a, b) => Number(b.id) - Number(a.id))
      return (
        <Box>
          <ResponsiveGrid columns="150px" gap="small">
            <DataBoxStyle>
              <LabelStyle>ID da parcela</LabelStyle>
              <InfoTextStyle>{installment.id}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Valor da parcela</LabelStyle>
              <InfoTextStyle>{formatNumberToBRL(installment.installmentValue)}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Ordem da parcela</LabelStyle>
              <InfoTextStyle>{installment.installmentOrder}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Vencimento</LabelStyle>
              <InfoTextStyle>{formatDate(installment.dueDate)}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Desconto/Acréscimo</LabelStyle>
              {differenceValue(installment.paymentDue, installment.installmentValue, installment.paidValue)}
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Valor atual</LabelStyle>
              <InfoTextStyle>{formatNumberToBRL(installment.paymentDue)}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Data da orginação</LabelStyle>
              <InfoTextStyle>{formatDate(installment.createdOn)}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Forma de pgto</LabelStyle>
              <InfoTextStyle>{paymentMethodString(installment.method, installment.paymentTimestamp)}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Data do pgto</LabelStyle>
              <InfoTextStyle>
                {installment.paymentTimestamp ? formatDateTreatingError(installment.paymentTimestamp) : '-'}
              </InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Link do boleto</LabelStyle>
              <InfoTextStyle>
                {sortedInvoices && sortedInvoices.length > 0 ? (
                  <Box direction="row" align="center" gap="medium">
                    <LinkAnchorStyle target="_blank" href={sortedInvoices[0].url + '.pdf'}>
                      {sortedInvoices[0]?.barcode?.slice(0, 5)
                        ? sortedInvoices[0]?.barcode?.slice(0, 5) + '...'
                        : '---------'}
                    </LinkAnchorStyle>
                    <div
                      title="Copiar código de barras"
                      onClick={() => toaster.showSuccessToast('Copiado para área de transferência')}
                    >
                      <Clipboard value={sortedInvoices[0].url + '.pdf'} />
                    </div>
                  </Box>
                ) : (
                  '-'
                )}
              </InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>ID do contrato</LabelStyle>
              <InfoTextStyle>{installment.contractId}</InfoTextStyle>
            </DataBoxStyle>

            <DataBoxStyle>
              <LabelStyle>Produto</LabelStyle>
              <InfoTextStyle>{translateSourceProduct(installment.sourceProduct)}</InfoTextStyle>
            </DataBoxStyle>
          </ResponsiveGrid>
        </Box>
      )
    }
    return (
      <CardStyle width="968px">
        {installment === undefined ? (
          <Box fill align="center" justify="center">
            <Loading />
          </Box>
        ) : installment instanceof Error ? (
          errorCard
        ) : (
          InstallmentDetailsCard(installment)
        )}
      </CardStyle>
    )
  }
}

export const CardStyle = styled(Card)`
  border-radius: 8px;
  padding: 24px;
  height: 230px;
`
